var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoMark = function SvgLogoMark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259.68,
    height: 223.34,
    viewBox: "0 0 259.68 223.34",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-194.4 -241.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10-2",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M428.96,291.31H219.52a25.118,25.118,0,0,1-25.12-25.12h0a25.118,25.118,0,0,1,25.12-25.12H428.96a25.118,25.118,0,0,1,25.12,25.12h0A25.131,25.131,0,0,1,428.96,291.31Z",
    fill: "#024c95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M395.61,349.83H251.75a25.035,25.035,0,0,1-25.03-25.03h0a25.035,25.035,0,0,1,25.03-25.03H395.61a25.035,25.035,0,0,1,25.03,25.03h0A25.035,25.035,0,0,1,395.61,349.83Z",
    fill: "#930767"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M363.18,408.45H285.3a25.139,25.139,0,0,1-25.14-25.14h0a25.139,25.139,0,0,1,25.14-25.14h77.88a25.139,25.139,0,0,1,25.14,25.14h0A25.146,25.146,0,0,1,363.18,408.45Z",
    fill: "#d79300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M330.72,464.41H316.64a24.168,24.168,0,0,1-24.17-24.17h0a24.168,24.168,0,0,1,24.17-24.17h14.08a24.168,24.168,0,0,1,24.17,24.17h0A24.168,24.168,0,0,1,330.72,464.41Z",
    fill: "#15b940"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_Mark.967833ad.svg";
export { ForwardRef as ReactComponent };